import { render, staticRenderFns } from "./ReferralDocumentTracking.vue?vue&type=template&id=60582906&"
import script from "./ReferralDocumentTracking.vue?vue&type=script&lang=js&"
export * from "./ReferralDocumentTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports